<template>
  <div class="h-full flex flex-col">
    <!-- ヘッダー -->
    <div class="flex items-center h-10 mx-5 my-3">
      <!-- 戻るボタン -->
      <div class="mr-4">
        <img
          src="@/assets/common/Icon_Left_black.svg"
          class="h-4"
          @click="gotoTimeLine()"
        />
      </div>
      <!-- タグ/投稿者検索 -->
      <div class="p-4 h-fit flex items-center flex-1 bg-gray200 rounded-[8px]">
        <div class="flex-1 relative h-4">
          <div class="absolute w-full left-0 h-[15px] text-left">
            <!-- 確認のために設定 -->
            <div
              class="text-W4 text-[15px] leading-[15px]"
              :class="selectedTagTextClass"
            >
              {{ selectTag }}
            </div>
          </div>
          <input
            type="text"
            class="absolute w-full left-0 opacity-0"
            readonly
            @click="isShowTagSearchSuggest = true"
          />
        </div>
      </div>
    </div>
    <!-- マップ -->
    <NearbySearchMap
      ref="NearbySearchMap"
      :mapElementId="mapElementId"
      :centerOffset="mapCenterOffset"
      :isOperable="isOperable"
      :spotList="spotList"
      :isScrollCardList="isScrolling"
      :copyrightBottomSpace="6"
      :selectedCardInfo="selectedSpot.item"
      :mapRangePadding="mapRangePadding"
      :isPagination="isPagination"
      :isFetchSpotFailed="isFetchFailed"
      @click-research-now-area="loadSpots()"
      @map-move="updateCardStatus()"
      @tap-spot="updateSelectedSpotCard($event)"
      @transition="goToSpotDetail($event)"
    />
    <!-- スポットカードリスト -->
    <div class="relative">
      <HorizontalSpotCardSlide
        v-if="!isFetchFailed"
        ref="HorizontalSpotCardSlide"
        :items="spotList"
        :isShowSpotCard="isShowSpotCard"
        :stopDebounceMs="120"
        :tappedPinIndex="selectedSpot.index"
        @scrolling="isScrolling = true"
        @scroll-end="isScrolling = false"
        @change="updateSelectedSpotCard($event)"
        @pagination="handlePagination($event)"
        @transition="goToSpotDetail($event)"
      />
      <!-- 取得失敗 -->
      <transition name="fail">
        <div
          v-if="isFetchFailed"
          class="absolute w-[299px] h-[194px] bottom-0 mb-[65px] flex-1 bg-white w-full rounded-[10px] left-0 right-0 pl-4 py-4 pr-3 m-auto"
        >
          <div class="text-W4 text-gray400 text-[13px] leading-[20px]">
            <span>
              投稿を取得できませんでした
              <br />
              条件を変えて検索してください
            </span>
          </div>
          <div class="my-2 flex justify-center">
            <img :src="errorSrc" class="h-[100px] w-[100px]" />
          </div>
        </div>
      </transition>
    </div>
  </div>
  <!-- タグ検索パネル -->
  <TagSearchSuggest
    :isShowTagSearchSuggest="isShowTagSearchSuggest"
    :isScreenNearbySearch="isScreenNearbySearch"
    @click-back-button="isShowTagSearchSuggest = false"
    @click-search-spot-without-tag="loadSpots(defaultTag)"
    @select-tag="loadSpots($event)"
  />
</template>
<script>
import TagSearchSuggest from '@/components/organisms/dokoiku/TagSearchSuggest.vue'
import NearbySearchMap from '@/components/molecules/dokoiku/NearbySearchMap.vue'
import SpotCard from '@/components/molecules/dokoiku/SpotCard.vue'
import CommentCardForTagResult from '@/components/organisms/dokoiku/CommentCardForTagResult.vue'
import HorizontalSpotCardSlide from '@/components/molecules/HorizontalSpotCardSlide.vue'
import Util from '@/mixins/util'
import {navigateTo, goBackDokoiku, META_TAB} from '@/router'
import log from 'loglevel'

const FIRST_PAGE = 0
const DEFAULT_TAG_NAME = 'タグを検索'
const FOOTER_AND_CARD_LIST_SPACE = 13
const MAX_SPOT = 100 /** 最大取得スポット数 */
const MAP_CENTER_OFFSET = {
  lat: 0,
  lon: -231 / 2, // eslint-disable-line no-magic-numbers
}
const MAP_RANGE_PADDING = {
  top: 30,
  right: 15,
  left: 15,
  bottom: 259, // カードの高さ(194px) + フッターの高さ(52px) + カードリストとのスペース(13px)
}
const NearbySearch = {
  name: 'NearbySearch',
  components: {
    TagSearchSuggest,
    NearbySearchMap,
    SpotCard,
    CommentCardForTagResult,
    HorizontalSpotCardSlide,
  },
  mixins: [Util],
  data() {
    return {
      isShowTagSearchSuggest: false, // タグ検索パネル表示フラグ
      isShowSpotCard: true, // スポットカード表示フラグ
      mapElementId: this.$config.MAP_SCRIPT_ELEMENT_ID.DOKOIKU_MAP, // マップ要素のID
      defaultTag: DEFAULT_TAG_NAME, // このエリアを検索押下時に渡すタグ名
      errorSrc: Util.methods.getErrorAssetsSrc(), // 検索失敗時の画像パス
      isOperable: true, // マップの操作中フラグ
      tappedPinIndex: 0, // タップしたピンのインデックス
      selectedCardInfo: {}, // スワイプで操作後の選択されたカードのスポット情報
      mapCenterOffset: MAP_CENTER_OFFSET,
      mapRangePadding: MAP_RANGE_PADDING, // 検索範囲用のpadding情報
      isScrolling: false, // スクロール有無
      isPagination: false, // ページネーション有無
    }
  },
  computed: {
    /** スポット一覧 */
    spotList: {
      get() {
        return this.$store.state.DokoikuStore.nearbySearch.commentList
      },
      set(value) {
        let newList = []
        if (this.offset === FIRST_PAGE) {
          // 先頭ページ読み込みの場合、新しく置き換え
          newList = value
        } else {
          // 続きのページ読み込みの場合、スポット追加
          const currentCommentList =
            this.$store.state.DokoikuStore.nearbySearch.commentList
          const tmpCommentList = structuredClone(currentCommentList)
          tmpCommentList.push(...value)
          // ここで、101件目以降は落とす
          if (MAX_SPOT < tmpCommentList.length) {
            tmpCommentList.splice(MAX_SPOT)
          }
          newList = tmpCommentList
        }
        this.$store.commit('DokoikuStore/setNearbySearchInfo', {
          key: 'commentList',
          value: newList,
        })
      },
    },
    /** タグ検索にて選択したタグ名 */
    selectTag: {
      get() {
        return this.$store.state.DokoikuStore.nearbySearch.selectTag
      },
      set(value) {
        this.$store.commit('DokoikuStore/setNearbySearchInfo', {
          key: 'selectTag',
          value: value,
        })
      },
    },
    /** 選択ピンもしくは選択カードに紐づくスポット情報 */
    selectedSpot: {
      get() {
        return this.$store.state.DokoikuStore.nearbySearch.selectedSpot
      },
      set(value) {
        this.$store.commit('DokoikuStore/setNearbySearchInfo', {
          key: 'selectedSpot',
          value: value,
        })
      },
    },
    /** 検索範囲 */
    searchRange: {
      get() {
        return this.$store.state.DokoikuStore.nearbySearch.searchRange
      },
      set(value) {
        this.$store.commit('DokoikuStore/setNearbySearchInfo', {
          key: 'searchRange',
          value: value,
        })
      },
    },
    /** ページネーション情報 */
    offset: {
      get() {
        return this.$store.state.DokoikuStore.nearbySearch.offset
      },
      set(value) {
        this.$store.commit('DokoikuStore/setNearbySearchInfo', {
          key: 'offset',
          value: value,
        })
      },
    },
    /** 周辺検索画面である */
    isScreenNearbySearch() {
      return this.$route.name === this.$config.DISPLAY_DOKOIKU_NEARBY_SEARCH_MAP
    },
    /** 表示する選択されたタグのフォントカラー */
    selectedTagTextClass() {
      return this.selectTag === DEFAULT_TAG_NAME
        ? 'text-gray400'
        : 'text-gray600'
    },
    /** スポット一覧取得失敗有無 */
    isFetchFailed: {
      get() {
        return this.$store.state.DokoikuStore.nearbySearch.isFetchFailed
      },
      set(value) {
        this.$store.commit('DokoikuStore/setNearbySearchInfo', {
          key: 'isFetchFailed',
          value: value,
        })
      },
    },
  },
  async activated() {
    const prevPageMeta = this.$route.params.prevMeta
    const isGoBack = this.$route.params.isGoBack || false
    // ドコイク機能の画面内遷移で、前に進む遷移を行った場合は情報の更新を行う
    if (!isGoBack && prevPageMeta.tab == META_TAB.DOKOIKU) {
      await this.loadSpots()
    }
  },
  deactivated() {
    if (this.$route.fullPath === '/Timeline') {
      this.spotList = []
      this.$refs.NearbySearchMap.unmountProcess()
      this.$refs.HorizontalSpotCardSlide.unmountProcess()
    }
  },
  methods: {
    /** タイムライン画面に遷移 */
    gotoTimeLine() {
      this.$store.commit('DokoikuStore/initNearbySearchInfo')
      goBackDokoiku(this.$route.name)
    },
    /**
     * スポット一覧を設定
     * @param {string|undefined} tagName タグ名
     */
    async loadSpots(tagName) {
      this.isShowSpotCard = false /** カードリストを下ろす */
      this.isShowTagSearchSuggest = false /** タグ検索パネルを閉じる */
      this.isFetchFailed = false
      this.offset = 0 // オフセットのリセット
      /** 取得できていない場合は、カード要素がないためガード */
      if (this.$refs.HorizontalSpotCardSlide) {
        this.$refs.HorizontalSpotCardSlide.init()
      }

      /** タグの準備 */
      const tag = this.prepareTagName(tagName)

      /** スポット一覧取得 */
      this.$store.commit('startLoading')
      try {
        // マップの左上/右下の座標を準備
        const {topLeft, bottomRight} = this.$refs.NearbySearchMap.getMapRect({
          top: 5, // eslint-disable-next-line no-magic-numbers
          bottom: this.$config.FOOTER_HEIGHT + FOOTER_AND_CARD_LIST_SPACE, // マップの最下辺から65px(フッターの高さ(52px)+カードリストとのスペース(13px))上からを検索範囲としたい
        })
        const {item, isContinue} = await this.fetchSpotList(
          topLeft,
          bottomRight,
          tag
        )

        this.isFetchFailed =
          item.length === 0 /*eslint-disable-line no-magic-numbers */
        this.$refs.HorizontalSpotCardSlide.setIsContinue(isContinue)
        this.spotList = item // 取得したスポットをstoreに保存
        this.searchRange = {topLeft, bottomRight} // ページネーション時で、使用する
        this.offset = this.spotList.length // 次カードのオフセットを設定
      } catch (e) {
        this.isFetchFailed = true
        log.info(e)
        const status = e?.response?.status
        if (status === this.$config.API_STATUS_CODE_SERVICE_UNAVAILABLE) {
          // メンテナンスモードの場合、エラーをスローする
          throw e
        }
      } finally {
        this.$store.commit('endLoading')
        this.isShowSpotCard = true
        this.isPagination = false
      }
    },
    /** ページネーション操作時処理 */
    async handlePagination() {
      this.isOperable = false
      const prevSpotOffset = structuredClone(this.offset)

      /** タグの準備 */
      const tag = this.prepareTagName(this.selectTag)

      /** スポット一覧取得 */
      let tempSpot
      try {
        const {topLeft, bottomRight} = this.searchRange
        const {item, isContinue} = await this.fetchSpotList(
          topLeft,
          bottomRight,
          tag
        )
        this.$refs.HorizontalSpotCardSlide.setIsContinue(isContinue)
        tempSpot = item
        this.spotList = item // 取得したスポットをstoreに保存
        this.offset = this.spotList.length // 次カードのオフセットを設定
      } catch (e) {
        log.info(e)
        const status = e?.response?.status
        if (status === this.$config.API_STATUS_CODE_SERVICE_UNAVAILABLE) {
          // メンテナンスモードの場合、エラーをスローする
          throw e
        }
      } finally {
        this.isOperable = true
        this.$refs.HorizontalSpotCardSlide.paginationDone(
          prevSpotOffset,
          tempSpot?.length
        )
        this.isPagination = true
      }
    },
    /**
     * 投稿一覧取得処理部品
     * @param {object} topLeft 左上座標
     * @param {object} bottomRight 右下座標
     * @param {string|undefined} tag タグ名
     * @returns {object} 投稿一覧
     */
    fetchSpotList(topLeft, bottomRight, tag) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('DokoikuStore/fetchSpotList', {
          success: (result) => {
            resolve(result)
          },
          failed: () => {
            reject()
          },
          error: (e) => {
            reject(e)
          },
          filter: {
            // 検索条件 タグ
            tag: tag,
            // 検索条件 エリア
            area: {
              topLeft: `${topLeft.lat},${topLeft.lon}`,
              bottomRight: `${bottomRight.lat},${bottomRight.lon}`,
            },
          },
          // オフセット POSTなので、渡す前に文字列変換
          offset: String(this.offset),
        })
      })
    },
    /**
     * 座標情報の小数点以下第7位以降を切り捨て
     * @param {number} value 緯度or経度
     * @returns {string} 変換後数値
     */
    convertCoordSixDecimal(value) {
      // eslint-disable-next-line no-magic-numbers
      return Number.parseFloat(value).toFixed(6)
    },
    /**
     * タグ名の準備
     * @param {string|undefined} tagName タグ名
     * @returns {string|undefined} 検索条件に使用するタグ名
     */
    prepareTagName(tagName) {
      let tag
      if (tagName) {
        // 選択タグがあれば連携、保持する
        this.selectTag = tagName
        tag = tagName
      } else {
        // 選択済のタグ名を使用
        tag = this.selectTag
      }

      return tag !== DEFAULT_TAG_NAME ? tag : undefined
    },
    /**
     * タップされたピンのカードを選択カードとして更新
     * @param {object} event スポット情報
     */
    updateSelectedSpotCard(event) {
      this.isShowSpotCard = true
      // 更新することでカードリストコンポーネントにて、インデックスに紐づくカードまで自動スクロールさせる
      this.tappedPinIndex = event.index
      this.selectedSpot.index = event.index
      if (event.item) {
        this.selectedSpot.item = event.item
      }
    },
    /** マップ操作中の状態更新 */
    updateCardStatus() {
      this.isShowSpotCard = false // カードリストの非表示
      this.isScrolling = false // スクロール停止状態に更新
      this.isFetchFailed = false // 未取得カードの非表示
    },
    /**
     * 地点詳細画面へ遷移
     * @param {Object} spot 投稿の地点情報
     */
    goToSpotDetail(spot) {
      this.$store.commit('DokoikuStore/initSpotDetailInfo')
      this.$store.commit('DokoikuStore/setSpotDetailInfo', {
        key: 'selectedSpot',
        value: spot,
      })
      // 画面を離れる前にページ情報を保持
      this.$store.dispatch('PageControl/saveDokoikuHistoryPage', this.$route)
      navigateTo({name: this.$config.DISPLAY_DOKOIKU_SPOT_DETAIL})
    },
  },
}
export default NearbySearch
</script>
<style scooped>
/* カード降下のトランジション */
.fail-enter-active,
.fail-leave-active {
  transform: translate(0px, 0px) translateZ(1px);
  transition: transform 500ms;
}
/* カード上昇のトランジション */
.fail-enter-from,
.fail-leave-to {
  transform: translateY(100vh) translateY(0px) translateZ(1px);
  transition: transform 700ms;
}
</style>
